import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
export class ChanceGameFeatureConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        this.multipliers = new Map();
        if (this.dataExists(this.data)) {
            // Build the map from the object, which is a Record<string, number[]> of chance game id to multipliers.
            const obj = this.data.toObject();
            for (const [key, value] of Object.entries(obj)) {
                const multipliers = Array.isArray(value) ? value.map(Number) : [];
                this.multipliers.set(key, multipliers);
            }
        }
    }
    getMultipliers(id) {
        return this.multipliers.get(id) ?? [];
    }
    getIds() {
        return Array.from(this.multipliers.keys());
    }
}
//# sourceMappingURL=ChanceGameFeatureConfigData.js.map